import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseService } from "../baseService";

import * as modCF from '../../models/online/cfutbol';
import { Observable } from "rxjs";
import { Proxy } from "../proxy/proxy.service";


@Injectable()
export class ProyectoGanarService extends BaseService {

  datos: modCF.Online.ProyectoGanar = undefined;

  constructor(http: HttpClient, http2: Http) {
    super(http, http2);
  }

  /**
   * Guarda los datos del proyecto ganar
   * @param urlBase Url de la API a la que se tiene que conectar para guardar los datos
   * @returns Datos actualizados
   */
  guardar(urlBase: string): Observable<modCF.Online.ProyectoGanar> {
    return new Observable(observer => {
      this.http.post(this.DireccionBase(urlBase) + 'cFutbolActas/guardarProyectoGanar', this.datos)
        .subscribe({
          next: (resultado: modCF.Online.ProyectoGanar) => {
            this.datos = resultado;
            observer.next(resultado);
            observer.complete();
          },
          error: (error) => {
            console.error(error);
          }
        });
    });
  }

  inicializar(designacion: Proxy.PrDesignaciones): void {
    this.datos = {
      activadoProtocolo: undefined,
      fecha: new Date(),
      grupo: designacion.grupo,
      id: 0,
      idCalendario: designacion.idCalendario,
      idDesignacion: designacion.idDesignacion,
      idCompeticion: designacion.idCompeticion,
      idTemporada: 0,
      observaciones: "",
      situacionReconducida: false,
      visibleEnInstalacion: false
    };
  }

  /**
   * Obtiene los datos del proyecto ganar asociado con la designación indicada.
   * @param urlBase Url de la API a la que se tiene que conectar para obtener los datos del Proyecto Ganar
   * @param idDesignacion Identificador de la designación
   * @returns Datos del registro con la información del proyecto Ganar
   */
  obtener(urlBase: string, idDesignacion: number): Observable<modCF.Online.ProyectoGanar> {
    return new Observable(observer => {
      this.http.get(this.DireccionBase(urlBase) + 'cFutbolActas/obtenerProyectoGanar?idDesignacion=' + idDesignacion.toString())
        .subscribe({
          next: (resultado: modCF.Online.ProyectoGanar) => {
            this.datos = resultado;
            observer.next(resultado);
            observer.complete();
          },
          error: (error) => {
            console.error(error);
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ganar.services.ts